import React from "react";
import { View, Text, StyleSheet } from "@react-pdf/renderer";
import dayjs from "dayjs";

const styles = StyleSheet.create({
  table: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#ccc",
    marginBottom: 10,
  },
  row: {
    flexDirection: "row",
    width: "100%",
  },
  headerRow: {
    backgroundColor: "#f3f4f6",
  },
  cell: {
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#ccc",
    padding: 4,
    fontSize: 9,
    textAlign: "center",
    flexGrow: 1,
    flexBasis: "10%",
  },
  componentCell: {
    flexBasis: "25%", // ✅ first column wider
    flexGrow: 0,
    textAlign: "left",
    fontWeight: "bold",
    paddingLeft: 5,
  },
  yes: {
    backgroundColor: "#ecfdf5",
    color: "#16a34a",
    fontWeight: "bold",
  },
  no: {
    backgroundColor: "#fef2f2",
    color: "#dc2626",
    fontWeight: "bold",
  },
  na: {
    color: "#9ca3af",
  },
});

const VehicleCheckTablePDF = ({ fullWeekDates, weekData, vehicleComponents }) => (
  <View style={styles.table}>
    {/* Header */}
    <View style={[styles.row, styles.headerRow]}>
      <Text style={[styles.cell, styles.componentCell]}>Vehicle Component</Text>
      {fullWeekDates.map((date) => (
        <Text key={date} style={styles.cell}>
          {dayjs(date).format("DD MMM")}
        </Text>
      ))}
    </View>

    {/* Body */}
    {vehicleComponents.map((comp) => (
      <View key={comp} style={styles.row}>
        <Text style={[styles.cell, styles.componentCell]}>{comp}</Text>
        {fullWeekDates.map((date) => {
          const entry = weekData[date]?.[0] || {};
          const val = entry[comp] || "N/A";
          let cellStyle = [styles.cell];
          if (val === "Y") cellStyle.push(styles.yes);
          else if (val === "N") cellStyle.push(styles.no);
          else cellStyle.push(styles.na);

          return (
            <Text key={date + comp} style={cellStyle}>
              {val}
            </Text>
          );
        })}
      </View>
    ))}
  </View>
);

export default VehicleCheckTablePDF;
